"use strict";

module.exports = /*@ngInject*/function () {
  return function (input) {
    return input ? '<span class="text-success">On</span>' : '<span class="text-danger">Off</span>';
  };
};